<template>
  <SelectComponent ref="selector" :value="value" @input="$ev => $emit('input', $ev)" v-bind="$attrs">
    <template #item="{ item }">
      <Card :value="item" :disabled="isDisabled(item)" />
    </template>
    <template #empty>
      <Card />
    </template>
    <template #noresults="{ filter }">
      <div class="text--center">{{ $t('couldnotfindonquery', { query: filter.search }) }}</div>
    </template>
    <template #actions>
      <ButtonComponent
        :label="$tc('link')"
        icon="fa-pro-light:link"
        @click="$emit('input', { onModel: 'Link', ref: null, name: $tc('link') })"
      />
    </template>
  </SelectComponent>
</template>

<script>
import Card from '@/components/Flatfinder/Resources/Card'
import SelectComponent from '@/components/Select/Modal'

export default {
  name: 'FlatfinderSelect',
  props: {
    value: [Object, Array],
    disabledIds: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      link: {
        isActive: false,
        label: this.$tc('link'),
      },
    }
  },
  methods: {
    close() {
      this.$refs.selector.close()
    },
    isDisabled(item) {
      return this.disabledIds.includes(item.id)
    },
  },
  components: {
    Card,
    SelectComponent,
  },
}
</script>
